export const AttributionLinkingStrategyValues = [
  'NONE',
  'REQUIRE_CONTACT_GUID',
  'REQUIRE_USER_GUID',
  'REQUIRE_JOB_GUID',
  'REQUIRE_JOB_AND_USER_GUID',
  'REQUIRE_JOB_GUID_AND_OPTIONAL_USER_GUID',
  'REQUIRE_ATTRIBUTION_DESCRIPTION',
] as const

export const currentlySupportedAttributionLinkingStrategies = [
  'REQUIRE_CONTACT_GUID',
  'REQUIRE_ATTRIBUTION_DESCRIPTION',
  'NONE',
] as const satisfies readonly AttributionLinkingStrategy[]

export type AttributionLinkingStrategy = (typeof AttributionLinkingStrategyValues)[number]
